function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "Fill 1");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "check-an-address",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "outage-details---desktop-on-the-way",
  transform: "translate(-670.000000, -465.000000)",
  fill: "#FFFFFF"
}, React.createElement("g", {
  id: "Group-15",
  transform: "translate(640.000000, 455.000000)"
}, React.createElement("g", {
  id: "Group-8",
  transform: "translate(22.000000, 0.000000)"
}, React.createElement("path", {
  d: "M25.0090085,11.3653057 L24.5404939,10.9597604 C23.7626988,10.2861885 22.5937761,10.3613295 21.9071506,11.1286477 L14.0682275,19.8861157 L11.7020143,17.8327282 C10.9251114,17.1584372 9.75601026,17.2320052 9.06849263,17.9986045 L8.65417115,18.4605054 C8.31821794,18.8347719 8.14364003,19.3287606 8.1691086,19.8331306 C8.19471098,20.3372758 8.41790666,20.8105918 8.79007788,21.1490405 L13.1274069,25.1508789 C13.5028787,25.5061805 14.0062287,25.6913813 14.5205511,25.6640124 C15.0348735,25.6365985 15.5159664,25.3984126 15.851875,25.0050013 L25.2095457,14.0499759 C25.5365782,13.6671257 25.6989347,13.1692272 25.661334,12.665756 C25.6236887,12.1621051 25.3891638,11.6944517 25.0090085,11.3653057 Z",
  id: "Fill-1"
})))));

var SvgTick = function SvgTick(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "18px",
    height: "16px",
    viewBox: "0 0 18 16",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTick, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/tick.4006f47e.svg";
export { ForwardRef as ReactComponent };